// Number fields select their whole value on focus, so typing "2" into a
// field showing "1" gives 2, not 12. Installed once for the whole app.
const NUMERIC = 'input[type="number"], input[inputmode="numeric"], input[inputmode="decimal"]';

function numericInput(target: EventTarget | null): HTMLInputElement | null {
  return target instanceof HTMLInputElement && target.matches(NUMERIC) && !target.readOnly ? target : null;
}

export function installNumericSelectOnFocus(doc: Document = document): () => void {
  let clickFocusing: HTMLInputElement | null = null;

  const onMouseDown = (e: MouseEvent) => {
    const input = numericInput(e.target);
    clickFocusing = input && input !== doc.activeElement ? input : null;
  };
  const onFocusIn = (e: FocusEvent) => {
    numericInput(e.target)?.select();
  };
  // The mouseup that ends a focusing click would drop the caret where the
  // pointer is (Safari), undoing the selection: cancel that one only.
  const onMouseUp = (e: MouseEvent) => {
    if (clickFocusing && e.target === clickFocusing) e.preventDefault();
    clickFocusing = null;
  };

  doc.addEventListener('mousedown', onMouseDown, true);
  doc.addEventListener('focusin', onFocusIn);
  doc.addEventListener('mouseup', onMouseUp, true);
  return () => {
    doc.removeEventListener('mousedown', onMouseDown, true);
    doc.removeEventListener('focusin', onFocusIn);
    doc.removeEventListener('mouseup', onMouseUp, true);
  };
}
